import React from "react";
import { SubscriptionPriceTemplate } from "themes/application/payment/components";

function SubscriptionPrice(props) {
    return <SubscriptionPriceTemplate {...props} />;
}

export default SubscriptionPrice;
